import { createClient } from '@liveblocks/client';
import type { WithLiveblocks } from '@liveblocks/zustand';
import { liveblocks } from '@liveblocks/zustand';
import { TDescendant } from '@udecode/plate';
import { liveblocksPublicKey } from 'config';
import { BaseSelection } from 'slate';
import { create } from 'zustand';

export type UserPresence = {
  member: { email: string; id: string; avatar: string; firstname: string; lastname: string };
  // color: string;
};

export type DocState = {
  docs: TDescendant[];
  member: string;
  type: string;
  updateDoc: (docData: TDescendant[]) => void;
  updateVersionHistory: (docData: TDescendant[]) => void;
  updateMember: (member: string) => void;
  position: BaseSelection | Record<string, never>;
  presence: UserPresence;
  setPresence: (cursor: UserPresence) => void;
  setPosition: (pos: BaseSelection | Record<string, never>) => void;
  onDeselectEditor: any;
  onSetDeselectEditor: (value: any) => void;
  onRestoreVersion: any;
  setVersionRestorer: (value: any) => void;
};

const client = createClient({
  publicApiKey: liveblocksPublicKey,
  unstable_fallbackToHTTP: true,
}) as any;

//TODO:Liveblocks Immer
const useCollaborativeEditorStore = create<WithLiveblocks<DocState>>()(
  liveblocks(
    (set) => ({
      docs: [{ type: 'p', children: [{ text: '' }] }],
      member: '',
      type: 'document',
      onDeselectEditor: null,
      position: {},
      onRestoreVersion: null,
      presence: {
        member: { email: '', id: '', avatar: '', firstname: '', lastname: '' },
        // color: '',
      },
      setPresence: (presence) => {
        set((state) => {
          state.presence = presence;
          return state;
        });
      },
      setPosition: (pos) => {
        set((state) => {
          state.position = pos;
          return state;
        });
      },

      updateDoc: (value: TDescendant[]) => {
        set((state) => {
          state.docs = value;
          return state;
        });
      },
      //TODO:Replace with update doc for version history
      //Update doc giving a liveblockscircular reference error on version history update
      updateVersionHistory: (value: TDescendant[]) => {
        set(() => ({
          docs: value,
        }));
      },

      updateMember: (value: string) => {
        set((state) => {
          state.member = value;
          return state;
        });
      },
      onSetDeselectEditor: (value) => {
        set((state) => {
          state.onDeselectEditor = value;
          return state;
        });
      },
      setVersionRestorer: (value) => {
        set((state) => {
          state.onRestoreVersion = value;
          return state;
        });
      },
    }),
    {
      client,
      storageMapping: { docs: true, member: true, type: true },
      presenceMapping: { presence: true, position: true },
    }
  )
) as any;

export default useCollaborativeEditorStore;
